import { classifyScalar } from './classify-scalar'

const REGEX = {
  IN_SYNTAX: /^\$in\s*\[(.*?)]\s*$/i,
  QUOTED_STRING: /"((?:[^"\\]|\\.)*)"/g,
  // For $in values, unescape any backslash-escaped character
  ESCAPED_CHAR: /\\(.)/g,
}

export function looksLikeInSyntax(raw: string): boolean {
  const trimmed = raw.trim()
  if (REGEX.IN_SYNTAX.test(trimmed)) return true
  const normalized = normalizeInEnvelope(trimmed)
  return REGEX.IN_SYNTAX.test(normalized)
}

export function parseInSyntax(raw: string, preserveStrings = false): string {
  const content = raw.trim()
  const normalized = normalizeInEnvelope(content)
  const match = REGEX.IN_SYNTAX.exec(normalized)
  if (!match) return content

  const inner = match[1]
  // Normalize escaped quotes so we can detect quoted items properly
  const escapedQuote = String.raw`\"`
  const normalizedInner = inner.replaceAll(escapedQuote, '"')

  // Prefer quoted items
  const quotedValues = [...normalizedInner.matchAll(REGEX.QUOTED_STRING)].map(
    ([, str]) => unescapeInItem(str),
  )

  // Fallback: split by comma if no quoted items found
  const finalValues =
    quotedValues.length > 0
      ? quotedValues
      : normalizedInner
          .split(',')
          .map((part) => part.trim())
          .filter(Boolean)
          .map((part) =>
            unescapeInItem(
              part.startsWith('"') && part.endsWith('"')
                ? part.slice(1, -1)
                : part,
            ),
          )

  // For string-like schema fields (STRING/ENUM), skip coercion to preserve values as strings
  const coerced = preserveStrings
    ? finalValues
    : finalValues.map((valueItem) => classifyScalar(valueItem).value)
  return JSON.stringify(coerced)
}

function normalizeInEnvelope(text: string): string {
  // Convert escaped brackets to literal so $in\[...\] is recognized
  return text.replaceAll(String.raw`\[`, '[').replaceAll(String.raw`\]`, ']')
}

function unescapeInItem(text: string): string {
  // Unescape common sequences: ", -, [, ], \\ etc.
  return text.replaceAll(REGEX.ESCAPED_CHAR, (_match, ch: string) => ch)
}
